import H1 from "../../../Atoms/H1";
import { useTranslation } from "react-i18next";
import Select from "../../../Atoms/Select";
import H2 from "../../../Atoms/H2";
import Input from "../../../Atoms/Input";
import { useState } from "react";
import dayjs from "dayjs";

const Step2 = (props) => {

    const { i18n } = useTranslation('common');

    const defaultValues = props.defaultValues || {};

    // function setOnline(e) {
    //     console.log(e.target.checked)
    // }

    return (<>
        <H1>{i18n.language === "fr" ? "Participants" : "Participants"}</H1><br/>
        <div className="flexblock">
            <div style={{ minWidth: 'min(400px,100%)' }}>
                <H2>{i18n.language === "fr" ? "Participant 1" : "Participant 1"}</H2>
                <div className="flexblock">
                    <Input name="name1" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Nom" : "Name"} defaultValue={defaultValues.name1} />
                    <Input name="firstname1" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Prénom" : "First name"} defaultValue={defaultValues.firstname1} />
                </div><br />
                <div className="flexblock">
                    <Input name="email1" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Email" : "Email"} defaultValue={defaultValues.email1} />
                    <Input name="mobilephone1" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Téléphone mobile" : "Mobile phone"} defaultValue={defaultValues.mobilephone1} />
                </div><br />
                <div className="flexblock">
                    <Input name="landline1" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Téléphone fixe" : "Landline"} defaultValue={defaultValues.landline1} />
                    <Input name="jobtitle1" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Intitulé du poste" : "Job title"} defaultValue={defaultValues.jobtitle1} />
                </div><br />
            </div>
            <div style={{ minWidth: 'min(400px,100%)' }}>
                <H2>{i18n.language === "fr" ? "Participant 2" : "Participant 2"}</H2>
                <div className="flexblock">
                    <Input name="name2" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Nom" : "Name"} defaultValue={defaultValues.name2} />
                    <Input name="firstname2" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Prénom" : "First name"} defaultValue={defaultValues.firstname2} />
                </div><br />
                <div className="flexblock">
                    <Input name="email2" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Email" : "Email"} defaultValue={defaultValues.email2} />
                    <Input name="mobilephone2" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Téléphone mobile" : "Mobile phone"} defaultValue={defaultValues.mobilephone2} />
                </div><br />
                <div className="flexblock">
                    <Input name="landline2" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Téléphone fixe" : "Landline"} defaultValue={defaultValues.landline2} />
                    <Input name="jobtitle2" style={{ width: "100%" }} placeholder={i18n.language === "fr" ? "Intitulé du poste" : "Job title"} defaultValue={defaultValues.jobtitle2} />
                </div><br />
            </div>
        </div>
    </>);
}

export default Step2;